var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeodalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 58,
    viewBox: "0 0 76 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12992 56.1079L0.0279491 9.1169C-0.252112 7.57851 1.6383 6.52959 2.75854 7.64843L50.4389 55.2688C51.4891 56.3177 50.7189 57.996 49.3186 57.996H11.5104C10.3202 58.0659 9.33997 57.2268 9.12992 56.1079Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.684 26.1791L57.5804 56.6673C58.0705 57.1568 58.7007 57.4365 59.4008 57.4365C61.2912 57.4365 62.5515 55.5485 61.8514 53.8702L40.7768 1.63466C39.9366 -0.533085 36.856 -0.533089 35.9458 1.56473L26.9838 22.403C26.4937 23.7316 26.7738 25.2001 27.684 26.1791Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6001 28.3468L67.8026 56.3876C68.4327 58.0658 70.7432 57.6463 70.8832 55.8981L75.4342 8.69728C75.5743 7.01903 73.6838 6.10998 72.6336 7.29874L57.0202 25.4798C56.3901 26.249 56.1801 27.3678 56.6001 28.3468Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeodalLogo);
export default __webpack_public_path__ + "static/media/feodal-logo.b3e398deb3e8df50a09f26cfe7baac03.svg";
export { ForwardRef as ReactComponent };